// extracted by mini-css-extract-plugin
export default {"root":"styles_root__yLP6r","button":"styles_button__WwQaa","info":"styles_info__o00VQ","imageBlock":"styles_imageBlock__Eif5L"};